import { useEffect, useRef } from 'react'

const useRefetchWhenChangeId = (id, fetchData, fetchTimeline) => {
  const prevId = useRef(id)

  useEffect(() => {
    if (id !== prevId.current) {
      fetchData()
      if (fetchTimeline) fetchTimeline()
      prevId.current = id
    }
  }, [fetchData, fetchTimeline, id])
}

export default useRefetchWhenChangeId
